module.exports = __webpack_public_path__ + "static/computer-wine-3d5b85645f1e4f53d8e7c61ad76542a1.jpg";